<script lang="ts">import { resolvePromotionDescriptionDisplay } from "../data";
import { cfgToThemeCdnPath } from "@infinitro/config";
import { locale, t, Verbiage } from "@infinitro/content";
import PromoCardFooter from "./promo-item/promo-item-footer.svelte";
export let promo;
export let compact = false;
// Hardcoded jackpot logo path for now
// TODO: Replace with dynamic banner paths later
$: imageUrl = cfgToThemeCdnPath(compact ? "/promotions/jackpot/logo-m.png" : "/promotions/jackpot/logo-d.png");
$: promoDescriptionDisplay = resolvePromotionDescriptionDisplay(promo, $locale, $t);
</script>

<div class="promo-item-momentum" class:promo-item-momentum-compact={compact}>
	<div class="promo-item-momentum-aspect" class:promo-item-momentum-aspect-compact={compact}>
		<div class="variant-banner-container-detail-momentum">
			<div
				class="variant-banner-container-detail-momentum-glow variant-banner-container-detail-momentum-glow--top"
				aria-hidden="true"
			></div>
			<div
				class="variant-banner-container-detail-momentum-glow variant-banner-container-detail-momentum-glow--bottom"
				aria-hidden="true"
			></div>
			<div class="variant-banner-container-detail-momentum-text">
				<h2 class="momentum-title">{$t(promo.title as VerbiageKey)}</h2>
				<p class="momentum-description">{promoDescriptionDisplay}</p>
			</div>
			<div class="variant-banner-container-detail-momentum-logo-wrap">
				<img
					src={imageUrl}
					alt={$t(Verbiage.turbo_jackpot_logo_alt)}
					class="variant-banner-container-detail-momentum-logo"
				/>
			</div>
		</div>
	</div>
	{#if compact}
		<PromoCardFooter {promo} active={true} isDetail={false} isBigScreen={false} />
	{/if}
</div>

<style>
	.promo-item-momentum {
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	.promo-item-momentum-aspect {
		position: relative;
		width: 100%;
		flex: 1;
		display: flex;
		min-height: 0;
	}

	.variant-banner-container-detail-momentum {
		position: relative;
		width: 100%;
		flex: 1;
		height: 100%;
		padding: 20px 45% 20px 20px;
		background: rgba(255, 255, 255, 0.05);
		border-radius: 12px;
		overflow: hidden;
	}

	@media (min-width: 768px) {
		.promo-item-momentum-aspect:not(.promo-item-momentum-aspect-compact)
			.variant-banner-container-detail-momentum {
			padding: 55px 32% 55px 42px;
		}
	}

	.promo-item-momentum-aspect-compact .variant-banner-container-detail-momentum {
		border-radius: 12px 12px 0 0;
	}

	.variant-banner-container-detail-momentum-blur-wrap {
		position: absolute;
		pointer-events: none;
		z-index: 1;
		left: 50%;
		top: -14.1%;
		width: 63.71%;
		height: 248.24%;
		transform: translateX(-50%);
	}

	@media (min-width: 768px) {
		.promo-item-momentum-aspect:not(.promo-item-momentum-aspect-compact)
			.variant-banner-container-detail-momentum-blur-wrap {
			left: 69.18%;
			top: -18.07%;
			width: 19.69%;
			height: 248.24%;
			transform: none;
		}
	}

	.variant-banner-container-detail-momentum-blur {
		width: 100%;
		height: 100%;
		-o-object-fit: cover;
		   object-fit: cover;
		filter: blur(55.25px);
	}

	.variant-banner-container-detail-momentum-glow {
		position: absolute;
		width: 97.23%;
		height: 12.05%;
		filter: blur(55.25px);
		pointer-events: none;
		z-index: 2;
		left: 50%;
		transform: translateX(-50%);
	}

	.variant-banner-container-detail-momentum-glow--top {
		top: 0;
		background: #2b62eb;
	}

	.variant-banner-container-detail-momentum-glow--bottom {
		bottom: 0;
		background: #be2f49;
	}

	@media (min-width: 768px) {
		.promo-item-momentum-aspect:not(.promo-item-momentum-aspect-compact)
			.variant-banner-container-detail-momentum-glow {
			width: 30.05%;
		}

		.promo-item-momentum-aspect:not(.promo-item-momentum-aspect-compact)
			.variant-banner-container-detail-momentum-glow--top {
			left: calc(50% + 15.07%);
		}

		.promo-item-momentum-aspect:not(.promo-item-momentum-aspect-compact)
			.variant-banner-container-detail-momentum-glow--bottom {
			left: calc(50% + 14.55%);
		}
	}

	.variant-banner-container-detail-momentum-text {
		position: relative;
		z-index: 10;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 16px;
		width: 100%;
		max-width: 194px;
	}

	@media (min-width: 768px) {
		.promo-item-momentum-aspect:not(.promo-item-momentum-aspect-compact)
			.variant-banner-container-detail-momentum-text {
			max-width: 467px;
		}
	}

	.momentum-title {
		margin: 0;
		width: 100%;
		font-family: var(--font-main);
		font-weight: 800;
		font-size: 24px;
		line-height: 100%;
		letter-spacing: -0.5px;
		text-transform: uppercase;
		color: #ffffff;
	}

	@media (min-width: 768px) {
		.promo-item-momentum-aspect:not(.promo-item-momentum-aspect-compact) .momentum-title {
			font-size: 40px;
		}
	}

	.momentum-description {
		width: 100%;
		margin: 0;
		font-family: var(--font-main);
		font-weight: 700;
		font-size: 14px;
		line-height: 120%;
		letter-spacing: -0.5px;
		color: #ffffff;
	}

	@media (min-width: 768px) {
		.promo-item-momentum-aspect:not(.promo-item-momentum-aspect-compact) .momentum-description {
			font-size: 16px;
		}
	}

	.variant-banner-container-detail-momentum-logo-wrap {
		position: absolute;
		pointer-events: none;
		z-index: 5;
		top: 0;
		right: 0;
		bottom: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 50%;
	}

	@media (min-width: 768px) {
		.promo-item-momentum-aspect:not(.promo-item-momentum-aspect-compact)
			.variant-banner-container-detail-momentum-logo-wrap {
			width: 32%;
		}
	}

	.variant-banner-container-detail-momentum-logo {
		width: 100%;
		height: auto;
		max-height: 115%;
		-o-object-fit: contain;
		   object-fit: contain;
		transform: rotate(-10deg);
	}

	:global(.variant-aspect-ratio-box-mobile-momentum),
	:global(.variant-aspect-ratio-box-detail-momentum),
	:global(.variant-aspect-ratio-box-detail-mobile-momentum) {
		position: relative;
		width: 100%;
	}

	:global(.variant-aspect-ratio-box-mobile-momentum) > a {
		display: block;
		width: 100%;
		overflow: hidden;
}
</style>
